// Licensed to All Seasons Landscaping (2025) – see LICENSE.txt
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';  
import './styles/root.css';       
import './index.css';               

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

export default null;
